/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_info_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment information — If you subscribe to a paid plan, payment processing is handled by Polar.sh (our payment provider). We do not store your credit card numbers or banking details directly.`)
};

const es_privacy_info_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información de pago — Si te suscribes a un plan de pago, el procesamiento de pagos lo maneja Polar.sh (nuestro proveedor de pagos). No almacenamos directamente tus números de tarjeta de crédito ni datos bancarios.`)
};

const de_privacy_info_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlungsinformationen — Wenn Sie ein kostenpflichtiges Abo abschließen, wird die Zahlungsabwicklung von Polar.sh (übernommen. Wir speichern Ihre Kreditkartennummern oder Bankdaten nicht direkt.`)
};

const nl_privacy_info_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betalingsinformatie — Als u een betaald abonnement afsluit, wordt de betalingsverwerking afgehandeld door Polar.sh (onze betalingsprovider). We slaan uw creditcardnummers of bankgegevens niet rechtstreeks op.`)
};

const fr_privacy_info_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informations de paiement — Si vous souscrivez à un plan payant, le traitement des paiements est géré par Polar.sh (notre prestataire de paiement). Nous ne stockons pas directement vos numéros de carte bancaire ni vos coordonnées bancaires.`)
};

const it_privacy_info_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni di pagamento — Se sottoscrivi un piano a pagamento, l’elaborazione dei pagamenti è gestita da Polar.sh (il nostro fornitore di pagamenti). Non memorizziamo direttamente i numeri della tua carta di credito o i dati bancari.`)
};

const pt_br2_privacy_info_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informações de pagamento — Se você assinar um plano pago, o processamento de pagamentos é realizado pela Polar.sh (nosso provedor de pagamentos). Não armazenamos números de cartão de crédito ou dados bancários diretamente.`)
};

const pt_privacy_info_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informação de pagamento — Se subscrever um plano pago, o processamento do pagamento é feito pelo Polar.sh (nosso fornecedor de pagamentos). Não armazenamos diretamente os números do seu cartão de crédito ou dados bancários.`)
};

const ja_privacy_info_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支払い情報 — 有料プランに登録される場合、支払い処理はPolar.sh（当社の決済プロバイダー）が行います。クレジットカード番号や銀行口座情報を直接保存することはありません。`)
};

const zh_privacy_info_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支付信息 — 如果您订阅付费计划，支付处理由Polar.sh（我们的支付提供商）处理。我们不直接存储您的信用卡号或银行信息。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_info_payment = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_info_payment(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_info_payment", locale)
	if (locale === "en") return en_privacy_info_payment(inputs)
	if (locale === "es") return es_privacy_info_payment(inputs)
	if (locale === "de") return de_privacy_info_payment(inputs)
	if (locale === "nl") return nl_privacy_info_payment(inputs)
	if (locale === "fr") return fr_privacy_info_payment(inputs)
	if (locale === "it") return it_privacy_info_payment(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_info_payment(inputs)
	if (locale === "pt") return pt_privacy_info_payment(inputs)
	if (locale === "ja") return ja_privacy_info_payment(inputs)
	return zh_privacy_info_payment(inputs)
};